module.exports = __webpack_public_path__ + "static/img/10.40a5adf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/10.png
// module id = aLeb
// module chunks = 0